import React, {
  useState,
  useRef,
  useImperativeHandle,
  forwardRef,
  useEffect,
} from "react"
import { useDispatch, useSelector } from "react-redux"
import { useHistory } from "react-router-dom"
import { Card, Col, Row, CardBody } from "reactstrap"
import { Stage, Layer, Line, Image, Transformer } from "react-konva"
import * as Unicons from "@iconscout/react-unicons"
import Select from "react-select"

//Import Breadcrumb

import { v4 as uuidv4 } from "uuid"
import useImage from "use-image"
import Listen from "../../../../helpers/Listen"
import { CirclePicker } from "react-color"

const Canvas = forwardRef((props, ref) => {
  const INITIAL_CANVAS = {
    id: uuidv4(),
    images: [],
    lines: [],
  }

  const dispatch = useDispatch()
  const state = useSelector(state => state)
  const history = useHistory()
  const params = new URLSearchParams(location.search)
  const id = params.get("id")
  const [activeCanvas, setActiveCanvas] = useState(0)
  const [jsonCanvas, setJsonCanvas] = useState([])
  // const [] = useState
  const [selectedImage, setSelectedImage] = useState("")
  const [imageAtCanvas, setImageAtCanvas] = useState([])
  const [refresh, setRefresh] = useState(true)
  const [imageList, setImageList] = useState(null)
  const [image, setImage] = useState("")
  const [tool, setTool] = React.useState("")
  const [color, setColor] = React.useState("#00000")
  const [lines, setLines] = React.useState([])
  const [penSize, setPenSize] = React.useState(1)

  const isDrawing = React.useRef(true)
  const dragUrl = React.useRef()
  const stageRef = React.useRef()
  const sideBarRef = React.useRef()
  const divRef = useRef(null)
  const fileRef = useRef()

  useImperativeHandle(ref, () => ({
    saveCanvas() {
      // let details = []

      let details = []
      setActiveCanvas(0)
      let itr = [...jsonCanvas]
      let interval = 1000 //one second
      itr.forEach((itr, index) => {
        setTimeout(() => {
          const img = stageRef.current.toDataURL()
          details.push({
            image: img,
            json: itr,
          })
          if (index !== jsonCanvas.length - 1) setActiveCanvas(index + 1)
        }, index * interval)
      })

      return { details }
    },
  }))

  React.useEffect(() => {
    // if (jsonCanvas.length === 0) {
    //   console.log("INI")
    //   setJsonCanvas([...jsonCanvas, INITIAL_CANVAS])
    // }
    const temp = localStorage.getItem("canvasCorporateOrder")
      ? JSON.parse(localStorage.getItem("canvasCorporateOrder"))
      : [INITIAL_CANVAS]

    setJsonCanvas(temp)
  }, [])

  React.useEffect(() => {
    setImageList(state.rtwCanvas.imageList)
  }, [state.rtwCanvas.imageList])

  React.useEffect(() => {
    Listen.addListener("back", eventResponse)
    return () => Listen.removeListener("back", eventResponse)
  }, [])

  const eventResponse = payload => {
    history.goBack()
  }

  React.useEffect(() => {
    setTimeout(() => {
      saveCanvas()
    }, 2000)
  }, [props.trigger])

  const [dimensions, setDimensions] = useState({
    width: 0,
    height: 0,
    sideBar: 0,
  })

  useEffect(() => {
    if (divRef.current?.offsetHeight && divRef.current?.offsetWidth) {
      setDimensions({
        width: document.getElementById("canvas-container").clientWidth,
        height: divRef.current.offsetHeight,
        sideBar: sideBarRef.current?.offsetWidth,
      })
    }
  }, [dimensions.height, dimensions.width])

  const handleDragStart = e => {
    const id = e.target.id()
  }
  const handleDragEnd = e => {
    const findIndexImage = jsonCanvas[activeCanvas].images.findIndex(
      image => image.id === e.imageProps.id
    )
    const cpArr = [...jsonCanvas]
    cpArr[activeCanvas].images[findIndexImage].x = e.e.target.x()
    cpArr[activeCanvas].images[findIndexImage].y = e.e.target.y()
    setJsonCanvas(cpArr)
  }

  const saveProductImages = e => {
    const files = e.target.files
    const body = {
      files,
      id,
    }
    setRefresh(false)
    dispatch(addNewSheet(body))
  }

  const saveCanvas = async e => {
    const uri = await stageRef?.current?.toDataURL()

    const image = uri
    const body = {
      jsonCanvas,
      image,
    }
    props.setCanvas(body)
  }

  const storeCanvasImage = (image, e) => {
    console.log(jsonCanvas)
    const cpArr = [...jsonCanvas]
    const initImage = {
      id: uuidv4(),
      img: image,
      x: e?.x ? e.x - 80 : 3.7215947601310404,
      y: e?.y ? e.y - 80 : 1.903710193068207,
      transformX: 0,
      transformY: 0,
      height: image.height || 413.3775398069322,
      width: image.width || 204.27840523986873,
    }

    cpArr[activeCanvas].images.push(initImage)

    setJsonCanvas(cpArr)
    localStorage.setItem("canvasCorporateOrder", JSON.stringify(cpArr))
  }

  const handleMouseDown = e => {
    isDrawing.current = true
    const pos = e.target.getStage().getPointerPosition()
    const clickedOnEmpty = e.target === e.target.getStage()
    if (clickedOnEmpty) {
      setSelectedImage(null)
    }

    setLines([
      ...lines,
      { tool, points: [pos.x, pos.y], color, width: penSize },
    ])

    const cpArr = [...jsonCanvas]

    cpArr[activeCanvas]?.lines.push({
      id: uuidv4(),
      tool,
      points: [pos.x, pos.y],
      color,
      width: penSize,
    })
    setJsonCanvas(cpArr)
    localStorage.setItem("canvasCorporateOrder", JSON.stringify(cpArr))
  }

  const handleTransformEnd = e => {
    const findIndexImage = jsonCanvas[activeCanvas].images.findIndex(
      image => image.id === e.id
    )
    const cpArr = [...jsonCanvas]
    cpArr[activeCanvas].images[findIndexImage].height = e.height
    cpArr[activeCanvas].images[findIndexImage].width = e.width

    setJsonCanvas(cpArr)
    localStorage.setItem("canvasCorporateOrder", JSON.stringify(cpArr))
  }

  const handleMouseMove = e => {
    // no drawing - skipping
    if (!isDrawing.current) {
      return
    }

    if (tool === "") {
      return
    }
    const stage = e.target.getStage()
    const point = stage.getPointerPosition()
    let lastLine = lines[lines.length - 1]
    // add point
    if (lastLine?.points) {
      lastLine?.points.concat([point.x, point.y])

      // replace last
      lines.splice(lines.length - 1, 1, lastLine)
      setLines(lines.concat())

      // ARRAY
      const cp = [...jsonCanvas]
      const linelength = cp[activeCanvas].lines.length
      const lastLinesObj = cp[activeCanvas].lines[linelength - 1]
      lastLinesObj.points = lastLinesObj?.points.concat([point.x, point.y])
      cp[activeCanvas].lines.splice(linelength - 1, 1, lastLinesObj)
      const a = cp[activeCanvas].lines.concat()
      setJsonCanvas(cp)
      localStorage.setItem("canvasCorporateOrder", JSON.stringify(cp))
    }
  }

  const handleMouseUp = () => {
    isDrawing.current = false
  }

  return (
    <div className="mt-4">
      <Row style={{ backgroundColor: "#fff" }}>
        <Col className="col-9">
          <Row>
            <Col
              className="col-1 p-2"
              style={{
                backgroundColor: "#f2f2f5",
                justifyItems: "center",
                alignItems: "center",
                // display: "flex",
                flexDirection: "column",
                maxWidth: 55,
              }}
            >
              <div
                style={{
                  maxWidth: 50,
                  backgroundColor: tool === "pen" ? "#dbdbdb" : "#fff",
                  aspectRatio: 1,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  borderRadius: 5,
                  marginBottom: 4,
                }}
              >
                <Unicons.UilEditAlt
                  role="button"
                  size="25"
                  color="#000"
                  onClick={() => setTool("pen")}
                />
              </div>
              <div
                style={{
                  maxWidth: 50,
                  backgroundColor: tool !== "pen" ? "#dbdbdb" : "#fff",
                  aspectRatio: 1,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  borderRadius: 5,
                  marginBottom: 4,
                }}
              >
                <Unicons.UilCapsule
                  role="button"
                  size="25"
                  color="#000"
                  onClick={() => setTool("eraser")}
                />
              </div>
            </Col>
            <Col className="col-11">
              <Card>
                <CardBody className="p-3">
                  <div
                    ref={divRef}
                    style={{
                      width: "100%",
                      height: "65vh",
                    }}
                    onDrop={e => {
                      e.preventDefault()
                      stageRef.current.setPointersPositions(e)
                      storeCanvasImage(
                        dragUrl.current,
                        stageRef.current.getPointerPosition()
                      )
                    }}
                    onDragOver={e => e.preventDefault()}
                    id="canvas-container"
                  >
                    <Stage
                      width={dimensions.width}
                      height={dimensions.height}
                      style={{
                        backgroundColor: "#fff",
                        border: "1px solid grey",
                      }}
                      onTouchstart={handleMouseDown}
                      onTouchmove={handleMouseMove}
                      onTouchend={handleMouseUp}
                      onMousedown={handleMouseDown}
                      onMousemove={handleMouseMove}
                      onMouseup={handleMouseUp}
                      ref={stageRef}
                    >
                      <Layer
                        width={dimensions.width}
                        height={dimensions.height}
                      >
                        {jsonCanvas.length > 0 &&
                          jsonCanvas[activeCanvas]?.images.map((image, i) => {
                            console.log("image>>>")
                            console.log(image)
                            return (
                              <Images
                                key={i}
                                imageProps={image}
                                isSelected={image.id === selectedImage}
                                onSelect={() => {
                                  setSelectedImage(image.id)
                                }}
                                onChange={newAttrs => {
                                  const image = imageAtCanvas.slice()
                                  //   rects[i] = newAttrs;
                                  //   setRectangles(rects);
                                  handleTransformEnd(newAttrs)
                                }}
                                handleDragEnd={v => handleDragEnd(v)}
                                // crossorigin="anonymous"
                              />
                            )
                          })}

                        {jsonCanvas.length > 0 &&
                          jsonCanvas[activeCanvas]?.lines !== null &&
                          jsonCanvas[activeCanvas]?.lines.map((line, i) => (
                            <Line
                              key={i}
                              points={line.points}
                              stroke={line.color}
                              strokeWidth={line.width}
                              tension={0.5}
                              lineCap="round"
                              globalCompositeOperation={
                                line.tool !== ""
                                  ? line.tool === "eraser"
                                    ? "destination-out"
                                    : "source-over"
                                  : null
                              }
                            />
                          ))}
                      </Layer>
                    </Stage>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Col>

        <Col className="col-3" style={{ backgroundColor: "#f2f2f5" }}>
          <Card>
            <CardBody
              className="p-3 h-100"
              style={{ backgroundColor: "#f2f2f5" }}
            >
              <div ref={divRef} style={{ width: "100%", height: "65vh" }}>
                <Row style={{ height: "25%" }}>
                  <Col className="col-12">
                    <div ref={divRef} style={{ width: "100%", height: "65vh" }}>
                      <Row style={{ height: "25%" }}>
                        <Col className="col-12">
                          <div style={{ marginBottom: 4 }}>Pen Size</div>
                          <input
                            type="range"
                            id="pensize"
                            name="pensize"
                            min="0"
                            max="11"
                            style={{ width: "100%" }}
                            value={penSize}
                            onChange={e => setPenSize(e.target.value)}
                          />
                        </Col>
                        <Col className="col-12 mt-4">
                          <div style={{ marginBottom: 6 }}>Pen Color</div>
                          <CirclePicker
                            styles={{ width: "100%" }}
                            circleSize={20}
                            circleSpacing={5}
                            onChange={color => setColor(color.hex)}
                            width={"100%"}
                          />
                        </Col>
                      </Row>
                    </div>
                  </Col>
                </Row>

                <Row style={{ height: "75%" }}>
                  <Col className="col-12 mt-4">
                    <div style={{ marginBottom: 6 }}>Select Image</div>

                    <Select
                      placeholder=""
                      value={
                        imageList &&
                        imageList.filter(iL => iL.imageUrl === image)
                      }
                      getOptionLabel={imageList => imageList.name}
                      getOptionValue={imageList => imageList.imageUrl}
                      options={imageList}
                      onChange={val => setImage(val?.imageUrl)}
                    />
                  </Col>
                  <Col className="overflow-auto" style={{ height: "100%" }}>
                    <div className="mt-2">
                      <img
                        src={image}
                        // src="https://www.simplilearn.com/ice9/free_resources_article_thumb/what_is_image_Processing.jpg"
                        className="w-100 mb-4 rounded "
                        onClick={event => {
                          if (event.detail == 2) {
                            storeCanvasImage(image)
                          }
                        }}
                        draggable="true"
                        onDragStart={e => {
                          dragUrl.current = e.target.src
                        }}
                        onDragOver={e => e.preventDefault()}
                      />
                    </div>
                  </Col>
                </Row>
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>
      {/* </Container> */}
      {/* </div> */}
    </div>
  )
})

const Images = ({
  imageProps,
  isSelected,
  onSelect,
  onChange,
  handleDragEnd,
}) => {
  const shapeRef = React.useRef()
  const trRef = React.useRef()
  const [img] = useImage(imageProps.img)

  React.useEffect(() => {
    if (isSelected) {
      // we need to attach transformer manually
      trRef.current.nodes([shapeRef.current])
      trRef.current.getLayer().batchDraw()
    }
  }, [isSelected])

  return (
    <React.Fragment>
      <Image
        onClick={onSelect}
        onTap={onSelect}
        image={img}
        x={imageProps.x}
        y={imageProps.y}
        width={imageProps.width}
        height={imageProps.height}
        ref={shapeRef}
        {...imageProps}
        draggable={isSelected}
        onDragEnd={e => {
          handleDragEnd({ imageProps, e })

          onChange({
            ...imageProps,
            x: e.target.x(),
            y: e.target.y(),
          })
          // handleDragEnd
        }}
        onTransformEnd={e => {
          const node = shapeRef.current
          const scaleX = node.scaleX()
          const scaleY = node.scaleY()

          node.scaleX(1)
          node.scaleY(1)

          // console.log(scaleX)
          onChange({
            ...imageProps,
            x: node.x(),
            y: node.y(),
            // set minimal value
            width: Math.max(5, node.width() * scaleX),
            height: Math.max(node.height() * scaleY),
          })
        }}
      ></Image>
      {isSelected && (
        <Transformer
          ref={trRef}
          boundBoxFunc={(oldBox, newBox) => {
            // limit resize
            if (newBox.width < 5 || newBox.height < 5) {
              return oldBox
            }
            return newBox
          }}
        />
      )}
    </React.Fragment>
  )
}

export default Canvas
